import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { IWindowContent } from 'src/app/interfaces/os/window-content.interface';
import { ThemeService } from 'src/app/services/ux/theme.service';
import { IFrameData } from './iframe-data.interface';

@Component({
  selector: 'app-iframe-content',
  templateUrl: './iframe-content.component.html',
  styleUrls: ['./iframe-content.component.scss']
})
export class IframeContentComponent implements OnInit, IWindowContent {

  data: IFrameData = null;
  src: any = null;
  isLoading = true;

  constructor(private sanitizer: DomSanitizer, public theme: ThemeService) {
  }

  ngOnInit(): void {
  }

  start(data: IFrameData) {
    this.data = data;
    this.src = this.sanitizer.bypassSecurityTrustResourceUrl(data.src);
  }
}
